import React, { useState } from 'react';
import type { User } from 'shared/types.js';
import { api } from './api.js';
import { validatePassword, PasswordRequirements } from './common.js';

export const FirstUserSetup = ({ onSetupComplete }: { onSetupComplete: (user: User) => void }) => {
    const [username, setUsername] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');

        const passwordValidation = validatePassword(password);
        if (!passwordValidation.hasMinLength || !passwordValidation.hasNumber || !passwordValidation.hasUpperCase) {
            setError('Password does not meet the requirements.');
            return;
        }

        setIsLoading(true);
        try {
            const user = await api.post<User>('/api/setup/create-first-user', { username, password, name });
            onSetupComplete(user);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'An unknown error occurred.');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="login-page-container">
            <div className="login-form-container">
                <h1>Create Admin Account</h1>
                <p>Welcome! Let's set up the first account for the application.</p>
                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="setup-name">Name</label>
                        <input id="setup-name" type="text" value={name} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)} required autoComplete="name" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="setup-username">Username</label>
                        <input id="setup-username" type="text" value={username} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.currentTarget.value)} required autoComplete="username" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="setup-password">Password</label>
                        <input id="setup-password" type="password" value={password} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)} required autoComplete="new-password" />
                        <PasswordRequirements password={password} />
                    </div>
                    <button type="submit" disabled={isLoading}>{isLoading ? 'Creating...' : 'Create Account'}</button>
                    {error && <p className="login-error">Access Denied. Please see server admin for assistance.</p>}
                </form>
            </div>
        </div>
    );
};

export const Login = ({ onLoginSuccess }: { onLoginSuccess: (user: User) => void }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const user = await api.post<User>('/api/login', { username, password });
            onLoginSuccess(user);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'An unknown error occurred.');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="login-page-container">
            <div className="login-form-container">
                <h1>Metro Lookup Utility</h1>
                <p>Please log in to continue.</p>
                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input id="username" type="text" value={username} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.currentTarget.value)} required autoComplete="username" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input id="password" type="password" value={password} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)} required autoComplete="current-password" />
                    </div>
                    <button type="submit" disabled={isLoading}>{isLoading ? 'Logging in...' : 'Log In'}</button>
                    {error && <p className="login-error">Access Denied. Please see server admin for assistance.</p>}
                </form>
            </div>
        </div>
    );
};